<template>
  <div class="currencyItemComponentForm">
    <v-layout row wrap>
      <v-flex xs2 pa-2>
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-right="40"
          lazy
          transition="scale-transition"
          offset-y
          full-width
          max-width="290px"
        >
          <v-text-field
            slot="activator"
            v-model="dateFormatted"
            label="Datum"
            readonly
            @blur="date = parseDate(dateFormatted)"
          ></v-text-field>
          <v-date-picker
            v-model="date"
            no-title
            @input="menu = false"
            :max="maxDate"
          ></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs3 pa-2> </v-flex>
      <v-flex xs5 pa-2>
        <v-autocomplete
          ref="element_1"
          v-model="company_to_select"
          :items="company_to_items"
          item-value="id"
          item-text="name"
          label="Kupac"
          :rules="[(v) => !!v || 'Obavezan podatak']"
          required
          return-object
          lazy-validation
        ></v-autocomplete>
      </v-flex>
      <v-flex xs2 pa-2>
        <v-text-field
          ref="element_2"
          v-model="vrednost_prodaje"
          label="Vrednost"
          suffix="RSD"
          disabled
        ></v-text-field>
      </v-flex>
    </v-layout>
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-layout row wrap>
        <v-flex xs12 pa-2>
          <v-textarea
            v-model="opis"
            name="input-5-1"
            class="Description"
            label="Opis"
          ></v-textarea>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 pa-2 style="text-align: center">
          <v-btn
            id="HistoryButton"
            @click="otvoriModal"
            title="Izbor sorte, količine i cene"
          >
            <p>
              <v-icon>close</v-icon>
            </p> </v-btn
          ><!-- /#HistoryButton -->
        </v-flex>
      </v-layout>
      <!-- /.Tank -->

      <v-layout row wrap>
        <v-flex xs12>
          <v-btn :disabled="!valid" @click="submit" class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear" class="AppButtonOutlined">odustani</v-btn>
        </v-flex>
      </v-layout>
      <!-- /.Action buttons -->
    </v-form>
    <TokenComponent ref="frmtoken" />

    <v-dialog v-model="dialogNote" scrollable content-class="ModalInModal">
      <v-container>
        <div class="DataTable">
          <v-form ref="form_modal" v-model="validModal" lazy-validation>
            <a class="closeModalInModalBtn" @click.prevent="closeModalInModal">
              <v-icon>close</v-icon>
            </a>
            <!-- /.closeModalBtn -->
          </v-form>
          <v-form ref="form_modal_1" v-model="validModal" lazy-validation>
            <v-layout row wrap>
              <v-flex xs3 pa-2>
                <v-autocomplete
                  v-model="vineyard_grape_variety_select"
                  :items="vineyard_grape_variety_items"
                  item-text="name"
                  item-value="id"
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  :label="strSorta"
                  required
                  persistent-hint
                  return-object
                  v-on:change="changeRoute"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs8 pa-2>
                <v-select
                  v-model="vineyard_select"
                  :items="vineyard_items"
                  item-value="vineyardId"
                  item-text="vineyard"
                  :rules="[(v) => !!v || 'Obavezan podatak']"
                  :label="strVinograd"
                  required
                  persistent-hint
                  return-object
                  v-on:change="changeVineyardPom"
                ></v-select>
                <!--  -->
              </v-flex>
              <v-flex
                xs1
                pa-2
                style="
                  padding-top: 20px !important;
                  padding-left: 0px !important;
                  padding-top: 22px !important;
                  max-width: 40px !important;
                "
              >
                <img
                  data-v-68a7a11e=""
                  @click="changeVineyard"
                  title="Izbor berbe"
                  src="../assets/menuIcons/grozdje.png"
                  style="width: 32px; height: 32px; margin: 0 2px"
                  v-if="this.vineyard_select !== undefined"
                />
              </v-flex>
            </v-layout>
          </v-form>
          <v-layout row wrap>
            <v-flex xs2 pa-2>
              <v-text-field
                v-model="quantity"
                label="Količina"
                type="number"
                persistent-hint
                return-object
                :rules="[(v) => !!v || 'Obavezan podatak']"
                required
                v-on:change="changeVrednost_Kolicina"
                ref="element_4"
              ></v-text-field>
            </v-flex>
            <v-flex xs2 pa-2>
              <v-select
                v-model="jm_grozdja_select"
                :items="jm_items"
                item-text="mark"
                item-value="id"
                :rules="[(v) => !!v || 'Obavezan podatak']"
                label="JM"
                required
                persistent-hint
                return-object
                disabled
                ref="element_5"
              ></v-select>
            </v-flex>
            <v-flex xs3 pa-2>
              <v-text-field
                v-model="cena"
                label="Cena"
                type="number"
                required
                persistent-hint
                return-object
                :rules="[(v) => !!v || 'Obavezan podatak']"
                v-on:change="changeVrednost_Cena"
                ref="element_6"
              ></v-text-field>
            </v-flex>
            <v-flex xs1 style="padding-top: 23px; font-size: 16px">
              RSD/kg
            </v-flex>
            <v-flex xs3 pa-2>
              <v-text-field
                v-model="vrednost"
                label="Vrednost"
                type="number"
                :disabled="true"
                ref="element_7"
              ></v-text-field>
            </v-flex>
            <v-flex xs1 style="padding-top: 23px; font-size: 16px">
              RSD
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12 pa-2>
              <v-textarea
                v-model="opis_modal"
                name="input-5-1"
                class="Description"
                label="Opis"
                ref="element_8"
              ></v-textarea>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex
              xs12
              style="text-align: right; margin-bottom: 0px; padding-top: 15px"
            >
              <v-btn
                :disabled="!validModal"
                @click="submit_modal"
                class="AppButtonFilled"
                >Sačuvaj</v-btn
              >
              <v-btn @click="clear_modal" class="AppButtonOutlined"
                >odustani</v-btn
              >
            </v-flex>
          </v-layout>

          <v-layout column>
            <v-flex style="overflow: auto">
              <v-data-table
                :headers="headers"
                :items="items_modal"
                hide-actions
                class="elevation-1"
                :pagination.sync="pagination"
              >
                <template slot="headers" slot-scope="props">
                  <tr>
                    <th
                      v-for="header in props.headers"
                      :key="header.text"
                      :class="[
                        'column sortable',
                        pagination.descending ? 'desc' : 'asc',
                        header.value === pagination.sortBy ? 'active' : '',
                        header.align === 'left'
                          ? 'text-xs-left'
                          : header.align === 'right'
                          ? 'text-xs-right'
                          : 'text-xs-center',
                      ]"
                      @click="changeSort(header.value)"
                    >
                      <v-icon small v-if="header.sortable !== false"
                        >arrow_upward</v-icon
                      >
                      {{ header.text }}
                    </th>
                  </tr>
                </template>

                <template slot="items" slot-scope="props">
                  <tr>
                    <td
                      style="
                        width: 15%;
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.vineyardGrapeVariety.grapeVariety.name }}
                    </td>
                    <td
                      style="
                        width: 15%;
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ props.item.vineyardGrapeVariety.vineyard.name }}
                    </td>
                    <td
                      style="
                        width: 10%;
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        formatDateTime(props.item.vineyardOperationHarvest.date)
                      }}
                    </td>
                    <td
                      style="
                        width: 10%;
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ numberFormatDE(Number(props.item.quantity)) }} kg
                    </td>
                    <td
                      style="
                        width: 10%;
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{ Math.round(props.item.grapePrice * 100) / 100 }} RSD/kg
                    </td>
                    <td
                      style="
                        width: 20%;
                        text-align: right;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      {{
                        currencyFormatDE(
                          Math.round(
                            props.item.grapePrice * props.item.quantity * 100
                          ) / 100
                        )
                      }}
                      RSD
                    </td>
                    <td
                      style="
                        width: 20%;
                        text-align: center;
                        padding-left: 5px;
                        padding-right: 5px;
                      "
                    >
                      <img
                        class="DataTable__Button"
                        title="Izmena"
                        src="../assets/icons/zatabele/ico-edit2.svg"
                        alt="ulaz-grozdja"
                        @click="editItemModal(props.item)"
                      />

                      <img
                        class="DataTable__Button"
                        title="Brisanje"
                        src="../assets/icons/zatabele/ico-delete2.svg"
                        alt="delete-item"
                        @click="deleteItemModal(props.item)"
                      />
                    </td>
                  </tr>
                </template>
                <template slot="no-data">
                  <!-- <v-btn color="primary" @click="initialize">Reset</v-btn> -->
                  <v-alert
                    slot="no-results"
                    :value="true"
                    color="primary"
                    icon="info"
                    >Nema podataka.</v-alert
                  >
                </template>
                <v-alert
                  slot="no-results"
                  :value="true"
                  color="error"
                  icon="warning"
                  >Trazili ste "{{ search }}" ali nema rezultata.</v-alert
                >
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogSpisakBerbi"
      scrollable
      content-class="ModalInModal"
      persistent
    >
      <v-container style="padding: 10px">
        <div class="DataTable">
          <v-form ref="form_modal" v-model="valid" lazy-validation>
            <v-layout>
              <v-flex xs11 pa-2 style="font-size: 20px !important">
                {{ this.naslovSpisakBerbi }}
              </v-flex>
              <v-flex xs1 pa-2>
                <a
                  class="closeModalInModalBtn"
                  @click.prevent="closeModalInModalStanjeBarika"
                >
                  <v-icon>close</v-icon>
                </a>
              </v-flex>
            </v-layout>

            <v-layout column>
              <v-flex style="overflow: hidden">
                <v-data-table
                  item-key="harvestId"
                  :headers="headers_modal_spisak_berbi"
                  :items="items_modal_spisak_berbi"
                  hide-actions
                  class="elevation-1"
                  :pagination.sync="pagination2"
                  v-model="selected_berba_init"
                >
                  <template slot="headers" slot-scope="props_modal">
                    <tr>
                      <th
                        v-for="header in props_modal.headers"
                        :key="header.text"
                        :class="[
                          'column sortable',
                          pagination2.descending ? 'desc' : 'asc',
                          header.value === pagination2.sortBy ? 'active' : '',
                        ]"
                        @click="changeSort2(header.value)"
                      >
                        <v-icon small v-if="header.sortable !== false"
                          >arrow_upward</v-icon
                        >
                        {{ header.text }}
                      </th>
                    </tr>
                  </template>
                  <template slot="items" slot-scope="props_modal">
                    <tr :active="props_modal.selected">
                      <td style="text-align: center; padding: 5px">
                        <v-checkbox
                          primary
                          hide-details
                          :input-value="props_modal.selected"
                          @click="changeSelect(props_modal.item)"
                        ></v-checkbox>
                        <!-- @click="props_modal.selected = !props_modal.selected" -->
                      </td>
                      <td style="display: none">
                        {{ props_modal.item.harvestId }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.vineyard.name }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{ props_modal.item.grapeVariety.name }}
                      </td>
                      <td style="text-align: center; padding: 0px">
                        {{ formatDateTime(props_modal.item.date) }}
                      </td>
                      <td style="text-align: center; padding: 5px">
                        {{
                          props_modal.item.quantity +
                          " " +
                          props_modal.item.unitOfMeasure.name
                        }}
                      </td>
                    </tr>
                  </template>
                  <template slot="no-data">
                    <v-alert
                      slot="no-results"
                      :value="true"
                      color="primary"
                      icon="info"
                      >Nema podataka.</v-alert
                    >
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12>
                <v-btn
                  :disabled="!valid"
                  @click="submit_berba_modal"
                  class="AppButtonFilled"
                  >Sačuvaj</v-btn
                >
                <v-btn @click="clear_berba_modal" class="AppButtonOutlined"
                  >odustani</v-btn
                >
              </v-flex>
            </v-layout>
          </v-form>
        </div>
      </v-container>
    </v-dialog>
  </div>
</template>

<script>
import { serverBus } from "../main";
import { readJSON, daLiJeVinarija } from "../helpers/Functions";
import TokenComponent from "../components/Token";

export default {
  name: "VineyardSellingItem",
  data: () => ({
    company_to_select: undefined,
    company_to_items: [],
    dateFormatted: null,
    menu: "",
    date: null,
    valid: true,
    ID: "0",
    naziv: "",
    opis: "",
    quantity: undefined,
    vrednost: undefined,
    cena: undefined,
    dialogNote: false,
    valid: true,
    validModal: true,
    items_modal: [],
    opis_modal: undefined,
    jm_grozdja_select: undefined,
    jm_items: [],
    vineyard_grape_variety_select: undefined,
    vineyard_grape_variety_items: [],
    vineyard_select: undefined,
    vineyard_items: [],
    selected_berba_init: [],
    selected_berba: [],
    pagination: {
      sortBy: "id",
      rowsPerPage: 10000000,
    },
    pagination2: {
      sortBy: "id",
      rowsPerPage: 10000000,
    },
    headers_modal_spisak_berbi: [],
    headers: [],
    items_modal_spisak_berbi: [],
    dialogSpisakBerbi: false,
    naslovSpisakBerbi: "Pregled berbi",
    ID_item: undefined,
    id_berbe: undefined,
    idVinograd: undefined,
    search: "",
    vrednost_prodaje: undefined,
    datum_berbe: undefined,
    ubrana_kolicina: undefined,
    item_za_izmenu: undefined,
    kilogram: undefined,
    vinarija: true,
    strSorta: "",
    strVinograd: "",
    index_izmene: -1,
  }),
  components: {
    TokenComponent,
  },
  watch: {
    date(val) {
      this.dateFormatted = this.formatDate1(this.date);
    },
  },
  computed: {
    maxDate() {
      const today = new Date();
      // const dd = today.getUTCDate();
      return this.formatDate(today);
    },
  },
  methods: {
    odrediVrednost(items) {
      let iznos = 0;

      items.forEach(function (entry) {
        iznos = iznos + entry.grapePrice * entry.quantity;
      });

      return this.numberFormatDE(iznos);
    },
    currencyFormatDE(num) {
      return num
        .toFixed(2) // always two decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    formatDateTime(date) {
      if (date !== undefined && date !== null) {
        let lokDate = date.split("T")[0];
        let lokTime = date.split("T")[1];

        let month = lokDate.split("-")[1];
        let day = lokDate.split("-")[2];
        const year = lokDate.split("-")[0];

        let HH = lokTime.split(":")[0];
        let mm = lokTime.split(":")[1];

        return [day, month, year].join("."); // + " " + [HH, mm].join(":");
      } else return "";
    },
    setDate() {
      const today = new Date();
      let Year = `${today.getFullYear()}`;
      let Month = `${today.getMonth() + 1}`;
      let Day = `${today.getDate()}`;

      if (Month.length < 2) Month = `0${Month}`;
      if (Day.length < 2) Day = `0${Day}`;

      this.date = [Year, Month, Day].join("-");
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    formatDate(date) {
      let month = `${date.getMonth() + 1}`;
      let day = `${date.getDate()}`;
      const year = date.getFullYear();

      if (month.length < 2) month = `0${month}`;
      if (day.length < 2) day = `0${day}`;

      return [year, month, day].join("-");
    },
    newSifarnik() {
      var complexObject = {
        company: {
          id: this.company_to_select.id,
        },
        date: this.date + "T00:00:00",
        description: this.opis,
        vineyardGrapeSellingItems: this.items_modal,
      };

      this.$http
        .post(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_grape_selling/create",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          serverBus.$emit("refresh_selling");
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .post(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_grape_selling/create",
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      serverBus.$emit("refresh_selling");
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      var complexObject = {
        id: this.ID,
        company: {
          id: this.company_to_select.id,
        },
        date: this.date + "T00:00:00",
        description: this.opis,
        vineyardGrapeSellingItems: this.items_modal,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_grape_selling/update",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          serverBus.$emit("refresh_selling");
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/currency/update/" +
                        this.ID,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      serverBus.$emit("refresh_selling");
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnikModal() {
      var complexObject = {
        id: this.ID,
        company: {
          id: this.company_to_select.id,
        },
        date: this.date + "T00:00:00",
        description: this.opis,
        vineyardGrapeSellingItems: this.items_modal,
      };

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_grape_selling/update",
          complexObject,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          // serverBus.$emit("refresh_selling");

          this.getAllSifarnik();
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/currency/update/" +
                        this.ID,
                      complexObject,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // serverBus.$emit("refresh_selling");

                      this.getAllSifarnik();
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSellers() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/company/all/buyers",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.company_to_items = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/company/all/buyers",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.company_to_items = response.data;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.prveraKupca())
        if (this.items_modal.length < 1)
          alert("Niste izabrali ni jednu sortu ni berbu.");
        else {
          if (this.ID != "" && this.ID != "0") {
            this.changeSifarnik();
          } else {
            this.newSifarnik();
          }

          this.clear();
        }
    },
    prveraKupca() {
      let odgovor = false;

      if (this.$refs.element_1.validate()) odgovor = true;
      else this.company_to_select = null;

      return odgovor;
    },
    clear() {
      this.setDate();

      this.$refs.element_1.reset();
      this.$refs.element_2.reset();
      this.$refs.form.reset();

      this.ID = 0;

      this.clear_modal();
      this.items_modal = [];
    },
    otvoriModal() {
      this.dialogNote = true;

      this.getAllJediniceMere();
      this.getAllSorteGrozdja();
      this.getAllVinograde(0);

      this.clear_modal();
    },
    clear_modal() {
      this.$refs.form_modal_1.reset();

      this.$refs.element_4.reset();
      this.$refs.element_6.reset();
      this.$refs.element_7.reset();
      this.$refs.element_8.reset();

      this.ID_item = undefined;
      this.id_berbe = undefined;

      this.idVinograd = undefined;
      this.item_za_izmenu = undefined;

      this.jm_grozdja_select = this.kilogram;

      this.index_izmene = -1;
    },
    proveraBerbe() {
      let odgovor = false;

      // console.log("this.vineyard_grape_variety_select.id - " + this.vineyard_grape_variety_select.id);
      // console.log("this.vineyard_select.vineyardId - " + this.vineyard_select.vineyardId);
      // console.log("this.id_berbe - " + this.id_berbe);

      // console.log(this.items_modal);

      if (this.index_izmene >= 0) this.items_modal.splice(this.index_izmene, 1);

      let _this = this;

      let index = this.items_modal.findIndex(
        (x) =>
          x.vineyardGrapeVariety.grapeVariety.id ===
            this.vineyard_grape_variety_select.id &&
          x.vineyardGrapeVariety.vineyard.id ===
            this.vineyard_select.vineyardId &&
          x.vineyardOperationHarvest.id === _this.id_berbe
      );

      // console.log(this.item_za_izmenu);

      if (index >= 0) {
        odgovor = true;
      }

      if (this.index_izmene >= 0) this.items_modal.push(this.item_za_izmenu);

      // console.log(this.items_modal);

      return odgovor;
    },
    submit_modal() {
      if (this.id_berbe == undefined || this.id_berbe == null)
        alert("Nije izabrana berba.");
      else if (!this.$refs.element_4.validate()) this.quantity = null;
      else if (!this.$refs.element_5.validate()) this.jm_grozdja_select = null;
      else if (!this.$refs.element_6.validate()) this.cena = null;
      else if (this.proveraBerbe()) {
        alert(
          this.vinarija
            ? "Izabrana kombinacija vinograda, sorte grožđa i berbe već postoji u prodaji koju kreirate/menjate."
            : "Izabrana kombinacija zasada, sorte ploda i berbe već postoji u prodaji koju kreirate/menjate."
        );
        this.clear_modal();
      } else if (this.$refs.form_modal_1.validate()) {

        if (this.ubrana_kolicina < this.quantity) {

          alert(
            "Uneli ste veću količinu od raspoložive na izaranoj berbi za prodaju."
          );
          this.clear_modal();
        } else {
          let _this = this;

          let nazivVinograda = "";

          this.vineyard_grape_variety_items.forEach(function (entry) {
            if (entry.id === _this.vineyard_grape_variety_select.id)
              nazivVinograda = entry.name;
          });

          let objgrozdje = {
            id: this.vineyard_grape_variety_select.id,
            name: nazivVinograda,
          };

          let objVinograd = {
            id: this.vineyard_select.vineyardId,
            name: this.vineyard_select.vineyard,
            vineyardGrapeVarietyId: this.vineyard_select.vineyardGrapeVarietyId,
          };

          let element = {
            vineyardGrapeVariety: {
              id: this.vineyard_select.vineyardGrapeVarietyId,
              grapeVariety: objgrozdje,
              vineyard: objVinograd,
            },
            vineyardOperationHarvest: {
              id: this.id_berbe,
              date: this.datum_berbe,
            },
            quantity: this.quantity,
            unitOfMeasure: {
              id: this.jm_grozdja_select.id,
            },
            grapePrice: this.cena,
            description: this.opis_modal,
          };

          if (
            this.ID_item != undefined &&
            this.ID_item != null &&
            this.ID_item != 0
          ) {
            let index;
            index = this.items_modal.findIndex((x) => x.id === this.ID_item);

            element.id = this.ID_item;

            if (index >= 0) this.items_modal.splice(index, 1);

            this.items_modal.push(element);
          } else {
            let index;

            if (this.item_za_izmenu !== undefined) {
              index = this.items_modal.findIndex(
                (x) =>
                  x.quantity === this.item_za_izmenu.quantity &&
                  x.grapePrice === this.item_za_izmenu.grapePrice &&
                  x.vineyardGrapeVariety.grapeVariety.id ===
                    this.item_za_izmenu.vineyardGrapeVariety.grapeVariety.id &&
                  x.vineyardGrapeVariety.vineyard.id ===
                    this.item_za_izmenu.vineyardGrapeVariety.vineyard.id
              );
              if (index >= 0) this.items_modal.splice(index, 1);

              element.id = this.ID_item;
            }

            this.items_modal.push(element);
          }

          if (this.ID > 0) this.changeSifarnikModal();
          else this.clear_modal();
        }
      }
    },
    changeVrednost_Cena(a) {
      if (a !== undefined && this.quantity !== undefined) {
        this.vrednost = Math.round(a * this.quantity * 100) / 100;
      } else this.vrednost = undefined;
    },
    changeVrednost_Kolicina(a) {
      if (a !== undefined && this.cena !== undefined) {
        this.vrednost = Math.round(a * this.cena * 100) / 100;
      } else this.vrednost = undefined;
    },
    closeModalInModal() {
      serverBus.$emit("refresh_selling");
      this.dialogNote = false;

      this.vrednost_prodaje = this.odrediVrednost(this.items_modal);

      this.clear_modal();
    },
    getAllJediniceMere() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/unit_of_measure/group/2",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.jm_items = [];
          let _this = this;
          this.kilogram;

          response.data.forEach(function (entry) {
            if (entry.mark !== "g") _this.jm_items.push(entry);

            if (entry.mark === "kg") _this.kilogram = entry;
          });

          this.jm_grozdja_select = this.kilogram;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/unit_of_measure/group/2",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.jm_items = [];
                      let _this = this;
                      let kilogram;

                      response.data.forEach(function (entry) {
                        if (entry.mark !== "g") _this.jm_items.push(entry);

                        if (entry.mark === "kg") kilogram = entry;
                      });

                      this.jm_grozdja_select = kilogram;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSorteGrozdja() {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/grape_variety/all",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.vineyard_grape_variety_items = response.data;
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  his.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/grape_variety/all",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.vineyard_grape_variety_items = response.data;
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeRoute(a) {
      // pobrisati sve osim id_prostorije
      this.selected_berba = [];

      this.vineyard_items = [];

      if (typeof a !== "undefined") {
        if (a.description !== undefined) {
          this.vineyard_select = undefined;
        }

        this.getAllVinograde(a.id);
      }
    },
    getAllVinograde(id) {
      if (typeof id !== "undefined")
        this.$http
          .get(
            this.globalServiceLocation +
              this.globalPort +
              "/vineyard_grape_variety/vineyard/grape_variety/" +
              id +
              "/external/false",
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer  " + localStorage.getItem("user-token"),
              },
            }
          )
          .then((response) => {
            this.vineyard_items = response.data;

            var indeks = this.vineyard_items.findIndex(
              (x) => x.vineyardId === this.idVinograd
            );
            this.vineyard_select = this.vineyard_items[indeks];
          })
          .catch((e) => {
            if (!e.response) {
              alert(this.$t("error.message"));
            } else {
              if (e.response.status === 401) {
                this.$refs.frmtoken
                  .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                  .then((result) => {
                    his.$http
                      .get(
                        this.globalServiceLocation +
                          this.globalPort +
                          "/vineyard_grape_variety/vineyard/grape_variety/" +
                          id +
                          "/external/false",
                        {
                          headers: {
                            "Content-Type": "application/json",
                            Authorization:
                              "Bearer  " + localStorage.getItem("user-token"),
                          },
                        }
                      )
                      .then((response) => {
                        this.vineyard_items = response.data;

                        var indeks = this.vineyard_items.findIndex(
                          (x) => x.vineyardId === this.idVinograd
                        );
                        this.vineyard_select = this.vineyard_items[indeks];
                      })
                      .catch((e) => {
                        let pomError = readJSON(e.response.data.message);
                        alert(pomError);
                      });
                  });
              } else {
                let pomError = readJSON(e.response.data.message);
                alert(pomError);
              }
            }
          });
    },
    changeVineyardPom(e) {
      if (e !== undefined)
        if (e.vineyardGrapeVarietyId !== undefined) {
          this.selected_berba_init = this.selected_berba;
        }
    },
    changeVineyard() {
      this.dialogSpisakBerbi = true;

      this.selected_berba = [];

      this.getAllSifarnikSpisakBerbi();
    },
    getAllSifarnikSpisakBerbi() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/grape_harvested/" +
            this.vineyard_select.vineyardId +
            "/" +
            this.vineyard_grape_variety_select.id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.items_modal_spisak_berbi = response.data;
          let _this = this;

          if (this.id_berbe !== undefined) {
            let index = this.items_modal_spisak_berbi.findIndex(
              (x) => x.harvestId === _this.id_berbe
            );

            if (index > -1) {
              this.selected_berba_init.push(
                this.items_modal_spisak_berbi[index]
              );

              if(this.index_izmene >= 0 && this.ID_item !== undefined)
                this.items_modal_spisak_berbi[index].quantity =
                  Number(this.items_modal_spisak_berbi[index].quantity) +
                  Number(this.quantity !== undefined ? this.quantity : 0);
            } else if (
              this.item_za_izmenu.vineyardOperationHarvest.id !== this.id_berbe
            ) {
              let pomObj = {
                harvestId: this.item_za_izmenu.vineyardOperationHarvest.id,
                date: this.item_za_izmenu.vineyardOperationHarvest.date,
                vineyard: this.item_za_izmenu.vineyardGrapeVariety.vineyard,
                grapeVariety:
                  this.item_za_izmenu.vineyardGrapeVariety.grapeVariety,
                unitOfMeasure: this.item_za_izmenu.unitOfMeasure,
                quantity: this.item_za_izmenu.quantity,
              };

              this.items_modal_spisak_berbi.push(pomObj);
              this.selected_berba_init.push(pomObj);
            }

            this.selected_berba = this.selected_berba_init;
          }
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/grape_harvested/" +
                        this.vineyard_select.vineyardId +
                        "/" +
                        this.vineyard_grape_variety_select.id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.items_modal_spisak_berbi = response.data;
                      let _this = this;

                      if (this.id_berbe !== undefined) {
                        let index = this.items_modal_spisak_berbi.findIndex(
                          (x) => x.harvestId === _this.id_berbe
                        );

                        if (index > -1) {
                          this.selected_berba_init.push(
                            this.items_modal_spisak_berbi[index]
                          );

                          if(this.index_izmene >= 0 && this.ID_item !== undefined)
                            this.items_modal_spisak_berbi[index].quantity =
                              Number(
                                this.items_modal_spisak_berbi[index].quantity
                              ) + Number(this.quantity !== undefined ? this.quantity : 0);
                        } else if (
                          this.item_za_izmenu.vineyardOperationHarvest.id !==
                          this.id_berbe
                        ) {
                          let pomObj = {
                            harvestId:
                              this.item_za_izmenu.vineyardOperationHarvest.id,
                            date: this.item_za_izmenu.vineyardOperationHarvest
                              .date,
                            vineyard:
                              this.item_za_izmenu.vineyardGrapeVariety.vineyard,
                            grapeVariety:
                              this.item_za_izmenu.vineyardGrapeVariety
                                .grapeVariety,
                            unitOfMeasure: this.item_za_izmenu.unitOfMeasure,
                            quantity: this.item_za_izmenu.quantity,
                          };

                          this.items_modal_spisak_berbi.push(pomObj);
                          this.selected_berba_init.push(pomObj);
                        }

                        this.selected_berba = this.selected_berba_init;
                      }
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_grape_selling/" +
            this.ID,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let _this = this;
          let items_pom = response.data;

          this.items_modal = [];

          items_pom.vineyardGrapeSellingItems.forEach(function (entry) {
            let element = {
              id: entry.id,
              vineyardGrapeVariety: {
                id: entry.vineyardGrapeVariety.id,
                grapeVariety: entry.vineyardGrapeVariety.grapeVariety,
                vineyard: entry.vineyardGrapeVariety.vineyard,
              },
              vineyardOperationHarvest: {
                id: entry.vineyardOperationHarvest.id,
                date: entry.vineyardOperationHarvest.vineyardOperationExecution
                  .date,
              },
              quantity: entry.quantity,
              unitOfMeasure: entry.unitOfMeasure,
              grapePrice: entry.grapePrice,
              description: entry.description,
              grapeRested: entry.quantity + (entry.remindedHarvestQuantity === null || entry.remindedHarvestQuantity === undefined ? 0 : entry.remindedHarvestQuantity)
            };

            _this.items_modal.push(element);
          });

          this.clear_modal();
        })
        .catch((e) => {
          if (!e.response) {
            alert(this.$t("error.message"));
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_grape_selling/" +
                        this.ID,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      let _this = this;
                      let items_pom = response.data;

                      this.items_modal = [];

                      items_pom.vineyardGrapeSellingItems.forEach(function (
                        entry
                      ) {
                        let element = {
                          id: entry.id,
                          vineyardGrapeVariety: {
                            id: entry.vineyardGrapeVariety.id,
                            grapeVariety:
                              entry.vineyardGrapeVariety.grapeVariety,
                            vineyard: entry.vineyardGrapeVariety.vineyard,
                          },
                          vineyardOperationHarvest: {
                            id: entry.vineyardOperationHarvest.id,
                            date: entry.vineyardOperationHarvest
                              .vineyardOperationExecution.date,
                          },
                          quantity: entry.quantity,
                          unitOfMeasure: entry.unitOfMeasure,
                          grapePrice: entry.grapePrice,
                          description: entry.description,
                          grapeRested: entry.quantity + (entry.remindedHarvestQuantity === null || entry.remindedHarvestQuantity === undefined ? 0 : entry.remindedHarvestQuantity)
                        };

                        _this.items_modal.push(element);
                      });

                      this.clear_modal();
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    closeModalInModalStanjeBarika() {
      console.log(this.selected_berba_init);

      if (this.selected_berba_init !== undefined && this.selected_berba_init !== null) {
        this.ubrana_kolicina = this.selected_berba_init[0].quantity;

        this.selected_berba = this.selected_berba_init;
        this.items_modal_spisak_berbi = [];
        this.selected_berba_init = [];
      }

      this.dialogSpisakBerbi = false;
    },
    submit_berba_modal() {
      this.selected_berba = this.selected_berba_init;

      this.datum_berbe = this.selected_berba_init[0].date;
      this.ubrana_kolicina = this.selected_berba_init[0].quantity;

      this.closeModalInModalStanjeBarika();
    },
    clear_berba_modal() {
      this.selected_berba = [];
      this.selected_berba_init = [];

      this.id_berbe = undefined;
    },
    changeSelect(e) {
      this.selected_berba_init = [];
      this.selected_berba_init.push(e);

      this.id_berbe = e.harvestId;
    },
    changeSort(column) {
      if (column !== "funkcije" && column !== "vrednost")
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending;
        } else {
          this.pagination.sortBy = column;
          this.pagination.descending = false;
        }
    },
    changeSort2(column) {
      if (column !== "funkcije" && column !== "vrednost")
        if (this.pagination2.sortBy === column) {
          this.pagination2.descending = !this.pagination2.descending;
        } else {
          this.pagination2.sortBy = column;
          this.pagination2.descending = false;
        }
    },
    numberFormatDE(num) {
      return num
        .toFixed(0) // always two decimal digits
        .replace(".", ",") // replace decimal point character with ,
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // use . as a separator
    },
    editItemModal(propsItem) {
      this.index_izmene = this.items_modal.indexOf(propsItem);

      let objSorta = {
        id: propsItem.vineyardGrapeVariety.grapeVariety.id,
      };
      this.vineyard_grape_variety_select = objSorta;

      this.idVinograd = propsItem.vineyardGrapeVariety.vineyard.id;

      this.ID_item = propsItem.id;

      this.quantity = propsItem.quantity;
      this.cena = propsItem.grapePrice;
      this.vrednost = propsItem.grapePrice * propsItem.quantity;
      this.opis_modal = propsItem.description;

      this.id_berbe = propsItem.vineyardOperationHarvest.id;

      this.ubrana_kolicina = propsItem.quantity + propsItem.grapeRested;

      let objJM = {
        id: propsItem.unitOfMeasure.id,
        name: propsItem.unitOfMeasure.nark,
      };

      this.jm_grozdja_select = objJM;

      this.item_za_izmenu = propsItem;
    },

    deleteItemModal(propsItem) {
      confirm("Da li ste sigurni da želite obrisati izabrani zapis?") &&
        this.brisanje(propsItem);
    },
    brisanje(item) {
      let index;

      if (item.id !== 0 && item.id !== undefined && item.id !== null)
        index = this.items_modal.findIndex((x) => x.id === item.id);
      else
        index = this.items_modal.findIndex(
          (x) =>
            x.quantity === item.quantity &&
            x.grapePrice === item.grapePrice &&
            x.vineyardGrapeVariety.grapeVariety.id ===
              item.vineyardGrapeVariety.grapeVariety.id &&
            x.vineyardGrapeVariety.vineyard.id ===
              item.vineyardGrapeVariety.vineyard.id
        );

      if (index !== -1) this.items_modal.splice(index, 1);

      if (this.ID !== 0 && this.ID !== undefined && this.ID !== null)
        this.changeSifarnikModal();
    },
  },
  mounted() {
    this.clear();
    this.getAllSellers();

    serverBus.$off("applied_selling");

    serverBus.$on("applied_selling", (item) => {
      this.ID = item.id;
      this.naziv = item.name;
      this.opis = item.description;
      this.date = item.date.split("T")[0];

      this.vrednost_prodaje = this.odrediVrednost(
        item.vineyardGrapeSellingItems
      );

      var indeksC = this.company_to_items.findIndex(
        (x) => x.id === item.company.id
      );

      this.company_to_select = this.company_to_items[indeksC];

      let _this = this;

      this.ID_item = undefined;

      this.items_modal = [];

      item.vineyardGrapeSellingItems.forEach(function (entry) {
        let element = {
          id: entry.id,
          vineyardGrapeVariety: {
            id: entry.vineyardGrapeVariety.id,
            grapeVariety: entry.vineyardGrapeVariety.grapeVariety,
            vineyard: entry.vineyardGrapeVariety.vineyard,
          },
          vineyardOperationHarvest: {
            id: entry.vineyardOperationHarvest.id,
            date: entry.vineyardOperationHarvest.vineyardOperationExecution
              .date,
          },
          quantity: entry.quantity,
          unitOfMeasure: {
            id: entry.unitOfMeasure.id,
          },
          grapePrice: entry.grapePrice,
          description: entry.description,
          grapeRested: entry.quantity + (entry.remindedHarvestQuantity === null || entry.remindedHarvestQuantity === undefined ? 0 : entry.remindedHarvestQuantity)
        };

        _this.items_modal.push(element);
      });
    });

    serverBus.$off("applied_selling_deleting");

    serverBus.$on("applied_selling_deleting", () => {
      this.clear();
    });

    serverBus.$off("otvori_modal");

    serverBus.$on("otvori_modal", (item) => {
      console.log(item);

      this.clear_modal();

      this.ID = item.id;
      this.naziv = item.name;
      this.opis = item.description;
      this.date = item.date.split("T")[0];

      this.vrednost_prodaje = this.odrediVrednost(
        item.vineyardGrapeSellingItems
      );

      var indeksC = this.company_to_items.findIndex(
        (x) => x.id === item.company.id
      );

      this.company_to_select = this.company_to_items[indeksC];

      let _this = this;

      this.items_modal = [];

      this.ID_item = undefined;

      item.vineyardGrapeSellingItems.forEach(function (entry) {
        let element = {
          id: entry.id,
          vineyardGrapeVariety: {
            id: entry.vineyardGrapeVariety.id,
            grapeVariety: entry.vineyardGrapeVariety.grapeVariety,
            vineyard: entry.vineyardGrapeVariety.vineyard,
          },
          vineyardOperationHarvest: {
            id: entry.vineyardOperationHarvest.id,
            date: entry.vineyardOperationHarvest.vineyardOperationExecution
              .date,
          },
          quantity: entry.quantity,
          unitOfMeasure: {
            id: entry.unitOfMeasure.id,
            name: entry.unitOfMeasure.mark,
          },
          grapePrice: entry.grapePrice,
          description: entry.description,
          grapeRested: entry.quantity + (entry.remindedHarvestQuantity === null || entry.remindedHarvestQuantity === undefined ? 0 : entry.remindedHarvestQuantity)
        };

        _this.items_modal.push(element);
      });

      this.dialogNote = true;

      this.getAllJediniceMere();
      this.getAllSorteGrozdja();
      this.getAllVinograde(0);
    });
  },
  beforeMount() {
    this.vinarija = daLiJeVinarija(localStorage.getItem("isWinery"));

    if (this.vinarija) {
      this.strSorta = "Sorta grožđa";
      this.strVinograd = "Vinograd";
    } else {
      this.strSorta = "Sorta ploda";
      this.strVinograd = "Zasad";
    }

    this.headers_modal_spisak_berbi = [
      { text: "", value: "vrednost", sortable: false },
      { text: this.strVinograd, value: "vineyard.name" },
      { text: this.strSorta, value: "grapeVariety.name" },
      { text: "Datum", value: "date" },
      { text: "Količina", value: "quantity" },
    ];

    this.headers = [
      { text: this.strSorta, value: "vineyardGrapeVariety.grapeVariety.name" },
      { text: this.strVinograd, value: "vineyardGrapeVariety.vineyard.name" },
      { text: "Datum berbe", value: "vineyardOperationHarvest.date" },
      { text: "Količina", value: "quantity" },
      { text: "Cena", value: "grapePrice" },
      { text: "Vrednost", value: "vrednost", sortable: false },
    ];
  },
};
</script>

<style lang="scss" scoped>
// .currencyItemComponentForm {
//   max-width: 430px;
// }

.Description textarea {
  height: 40px;
}

// .v-input.v-text-field {
// 	margin: 0px;
// }

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

.closeModalInModalBtn {
  position: absolute;
  right: 0;
  top: 0;
}

#HistoryButton {
  // position: fixed;
  // right: 10px;
  // bottom: 20px;
  padding: 0px;
  margin: 0px;
  width: 54px;
  height: 54px;
  font-size: 40px;
  border-radius: 50%;
  color: #ffffff;
  background-color: #018389;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
  transition: 0.2s ease-in-out;

  p {
    // position: relative;
    // width: 100%;
    // height: 100%;
    i {
      position: absolute;
      left: 14px;
      top: -2px;
      transform: rotate(45deg);
      color: #ffffff;
    }
  }

  &:active,
  &:focus {
    box-shadow: none;
  }
}

.v-btn {
  min-width: 0;
}

#Odustani_dugme {
  text-align: right !important;
}
</style>
